module.exports = __webpack_public_path__ + "img/18.094d9b2c.png";